import { Component, Input, NgZone, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnvFlagService } from '@merchant-portal/app/core/flag/services/env-flag.service';
import {
  SidebarState,
  SidebarStateService,
} from '@merchant-portal/app/services/sidebar-state.service';
import { Observable } from 'rxjs';
import { AuthService } from '../../core/auth.service';
import { IUserInfo } from '../../models/login/login.interface';
import { DialogComponentService } from '../dialog/dialog.component.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: false,
})
export class NavbarComponent {
  private flag = inject(EnvFlagService);
  hideHelpCenter = !this.flag.getFlag('show_help_center');
  hideNotification = !this.flag.getFlag('show_notfication');
  hideMyBusiness = !this.flag.getFlag('show_my_business');
  hideDeveloperSetting = !this.flag.getFlag('show_developer_setting');
  isAccountOpen = false;
  isNotificationOpen = false;
  sidebarState$: Observable<SidebarState>;

  @Input() userData: IUserInfo | null | undefined;
  constructor(
    private router: Router,
    private authService: AuthService,
    private dialogComponentService: DialogComponentService,
    private ngZone: NgZone,
    private sidebarStateService: SidebarStateService
  ) {
    this.sidebarState$ = this.sidebarStateService.state$;
  }
  logout() {
    this.authService.logout();
    this.ngZone.run(() => {
      this.router.navigate(['/logout']);
    });
  }
  openNotification() {
    this.isNotificationOpen = !this.isNotificationOpen;
  }
  showHelpCenterDialog() {
    this.dialogComponentService.openHelpCenterDialog({
      width: '700px',
      height: '500px',
      body: {
        title: 'Help Center',
        message: 'Please contact Helpdesk via email for assistance.',
      },
    });
  }

  onSettingClick() {
    if (this.sidebarStateService.currentState.isMobile) {
      this.router.navigate(['/account-setting']);
      setTimeout(() => {
        this.sidebarStateService.setSettingsDrawerOpen(true);
      });
    } else {
      this.router.navigate(['/account-setting']);
    }
  }

  get userInitials(): string {
    if (!this.userData?.name) {
      return '';
    }

    const nameParts = this.userData.name.trim().split(/\s+/);

    if (nameParts.length === 1) {
      return nameParts[0].substring(0, 2).toUpperCase();
    }

    const firstInitial = nameParts[0].charAt(0);
    const lastInitial = nameParts[nameParts.length - 1].charAt(0);

    return (firstInitial + lastInitial).toUpperCase();
  }
}
